//@ts-nocheck
import React from "react";
import styles from "./Svg.module.scss";
import HAMBURGER from "../../assets/images/hamburger.svg";
import WHITE_HAMBURGER from "../../assets/images/hamburger-white.svg";
import INFO_BUBBLE from "../../assets/images/white-info.svg";
import PROFILE from "../../assets/images/profile.svg";
import FORMS from "../../assets/images/form-icon.svg";
import FORM_OPTIONS from "../../assets/images/form-options-icon.svg";
import EXPAND from "../../assets/images/plus-sign.svg";
import CONTRACT from "../../assets/images/minus-sign.svg";
import LINKED from "../../assets/images/link.svg";
import GEAR from "../../assets/images/cloud_gear.svg";
import THREE_DOTS from "../../assets/images/three-dots.svg";
import SETTINGS from "../../assets/images/settings.svg";
import SETTINGS_DARK from "../../assets/images/settings_dark.svg";
import NAV_ARROW from "../../assets/images/nav_arrow.svg";
import ACTIONS from "../../assets/images/actions.svg";
import EDIT from "../../assets/images/edit.svg";
import MENU_MANAGER from "../../assets/images/menu_manager.svg";
import DELETE from "../../assets/images/delete.svg";
import SPINNER_SMALL from "../../assets/images/spinner_small.svg";
import SPINNER from "../../assets/images/spinner.svg";
import FILTER from "../../assets/images/filter_list.svg";
import HISTORY from "../../assets/images/history.svg";
import CLIPBOARD from "../../assets/images/clipboard.svg";
import MAIL from "../../assets/images/mail.svg";
import MAIL_DARK from "../../assets/images/mail_dark.svg";
import NAV_ARROW_DARK from "../../assets/images/nav_arrow_dark.svg";
import REFRESH from "../../assets/images/refresh.svg";
import SAVED_LOCALLY from "../../assets/images/saved_locally_icon.svg";
import AUTO_SYNC from "../../assets/images/auto_synced.svg";

const icons = {
	ACTIONS,
	CLIPBOARD,
	CONTRACT,
	DELETE,
	EDIT,
	EXPAND,
	FILTER,
	FORM_OPTIONS,
	FORMS,
	GEAR,
	HAMBURGER,
	HISTORY,
	INFO_BUBBLE,
	LINKED,
	MAIL,
	MAIL_DARK,
	MENU_MANAGER,
	NAV_ARROW,
	NAV_ARROW_DARK,
	PROFILE,
	REFRESH,
	SETTINGS,
	SETTINGS_DARK,
	SPINNER_SMALL,
	SPINNER,
	THREE_DOTS,
	WHITE_HAMBURGER,
	SAVED_LOCALLY,
	AUTO_SYNC,
};

function Svg(props) {
	const { cssClass, icon, name, onClick } = props;

	return !onClick ? (
		<img alt={icon} src={icons[icon]} className={styles[cssClass]} name={name} />
	) : (
		<input
			title={icon.toLowerCase()}
			type="image"
			alt="tag-icon"
			src={icons[icon]}
			className={styles[cssClass]}
			onClick={onClick}
			onKeyUp={onClick}
			name={name}
		/>
	);
}

export default Svg;
